module.exports = __webpack_public_path__ + "audio-8818e53346c5.m4a";